import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const archivedIssuesRedirectRoute: InvariantJiraRoute = {
	name: 'archived-issues-directory',
	path: '/jira/issues/archive',
	exact: true,
};
